import React from 'react';
import { motion } from 'framer-motion';
import DashboardTitle from './DashboardTitle/DashboardTitle';
import StatsCards from './StatsCards/StatsCards';
import BulkSendSection from './BulkSendSection/BulkSendSection';

interface SidebarProps {
  selectedLeadsCount: number;
  intervalConfig: { minInterval: number; maxInterval: number };
  onSaveIntervals: (min: number, max: number) => void;
  onSendSelected: () => void;
  isSending: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({
  selectedLeadsCount,
  intervalConfig,
  onSaveIntervals,
  onSendSelected,
  isSending,
}) => {
  return (
    <motion.div
      data-tour="sidebar-bulk-send"
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.4, duration: 0.6 }}
      className="flex flex-col gap-6"
    >
      <DashboardTitle />
      <StatsCards />
      <BulkSendSection
        selectedLeadsCount={selectedLeadsCount}
        intervalConfig={intervalConfig}
        onSaveIntervals={onSaveIntervals}
        onSendSelected={onSendSelected}
        isSending={isSending}
      />
    </motion.div>
  );
};

export default Sidebar;